<template>
  <div style="display: flex">
    <div :class="switchShow" style="flex: 1">
      <el-row>
        <el-col :span="17">
          <!-- 面包屑导航区域-->
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
            <el-breadcrumb-item>Setup</el-breadcrumb-item>
            <el-breadcrumb-item>Supplier</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
        <!-- <el-col class="el-breadcrumb__inner" font-size="3px" :span="6">
          Updating Time: {{ this.updateTime }}
          </el-col> -->
      </el-row>
      <el-card>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="Supplier Name:">
            <el-input v-model="formInline.supplierName" placeholder="Supplier Name" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">Search</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="customerDialogOpen('add')">Add</el-button>
          </el-form-item>
        </el-form>

        <!-- CRProject 列表区域 -->
        <el-table :data="roleList" border stripe style="width: 100%">
          <!--          <el-table-column type="index" label="#"></el-table-column>-->
          <el-table-column
            prop="id"
            label="Supplier Id"         sortable
            width="150">
          </el-table-column>
          <el-table-column
            prop="supplierName"
            label="Supplier Name"         sortable
            width="150">
          </el-table-column>
          <el-table-column
            prop="area"
            label="Area"
            width="150">
          </el-table-column>
          <el-table-column
            prop="category"      sortable
            label="Category"
            width="150">
          </el-table-column>
          <el-table-column
            prop="followers"
            label="Followers"
            width="150">
          </el-table-column>
          <el-table-column
            prop="address"
            label="address"
            width="150">
          </el-table-column>

          <el-table-column label="Operation" width="350">
            <template slot-scope="index">
              <!-- <el-button type="info" plain size="mini" @click="view(props.row.id)">View</el-button> -->
              <el-button type="info" plain size="mini" @click="getUsers(index)">Inspector <i class="el-icon-user"></i> {{index.row.qcUsersNum ? index.row.qcUsersNum : 0 }}</el-button>
              <!--              <el-button type="info" plain size="mini" @click="getPermissions(index)">Followers</el-button>-->
              <el-button type="info" plain size="mini" @click="edit(index)">Edit</el-button>
              <!--          <el-button type="info" plain size="mini" @click="del(props.row.code)">Delete</el-button>-->
            </template>
          </el-table-column>

        </el-table>

        <!-- 分页区域-->
        <!--<el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="formInline.page"
          :page-sizes="[10, 20, 30, 50, 100, total]"
          :page-size="formInline.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>-->
      </el-card>
      <el-dialog title="Supplier"
                 width="50%" :visible.sync="dialogFormVisible" >
        <el-form :model="supplier" label-width="200px" ref="userOpenform">
          <el-form-item required label="Supplier Name:" prop="supplier.supplierName">
            <el-input v-model="supplier.supplierName" style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item label="Id:" prop="supplier.id">
            <el-input v-model="supplier.id" style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item label="Area:" prop="supplier.area">
            <el-input v-model="supplier.area" style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item label="Category:" prop="supplier.category">
            <el-input v-model="supplier.category" style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item label="Followers:" prop="supplier.followers">
            <el-input v-model="supplier.followers" style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item label="Address:" prop="supplier.address">
            <el-input v-model="supplier.address" style="width: 300px"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">Cancel</el-button>
          <el-button type="primary" @click="customerDialogSave('userOpenform')">Save</el-button>
        </div>
      </el-dialog>
      <el-dialog :title=dialog
                 width="50%" :visible.sync="dialogFormVisible2">
        <div v-if="qcUserList.length>0"  v-loading="loading">
          <p> Add User: </p>
          <br><br>
          <div>
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">Select All</el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group v-model="checkedSupplierUser" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="(item, index) in qcUserList" :label="item.salesRep" :key="index" :value="item.salesRep">{{item.lastName}}({{item.salesRep}}) {{item.org}}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div style="text-align: right">
            <el-button @click="dialogFormVisible2 = false">Cancel</el-button>
            <el-button type="primary" @click="supplierUserSave('supplierUserSave')">Save</el-button>
          </div>
        </div>
        <div v-if="permissions.length>0">
          <p> Role Name: {{indexRole.roleName}}</p>
          <h5 v-for="item in this.permissions"
              :key="item"
              :label="item"
              :value="item"> Permission Name: {{ item.name }} Level: {{ item.level }} Menu Type: {{ item.menuType }} Hidden: {{ item.hidden }}</h5>
        </div>
      </el-dialog>
    </div>
    <div v-if = "switchShow === 'show'" style="flex: 1">
      <el-row>
        <el-col :span="17">
          <!-- 面包屑导航区域-->
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>Inspector</el-breadcrumb-item>
            <el-breadcrumb-item>Supplier: {{supplierInspector}}</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-card>
        <div style="display: flex">
          <div style="flex: 1;text-align: left">
            <el-button type="primary" @click="addUser()">Add User</el-button>
          </div>
          <div style="flex: 1;text-align: right">
            <el-button size="mini"  @click="closeSwich()">Close</el-button>
          </div>
        </div>
        <el-divider></el-divider>
        <div  v-loading="loading">
          <div style="display: flex;;height: 2rem;margin-top: 1rem" v-for="item in this.supplierUserList"
               :key="item"
               :label="item"
               :value="item">
            <p style="flex: 3"><i class="el-icon-user"></i> {{item.lastName}} ({{item.salesRep}})</p>
            <p style="flex: 1;text-align: right">
              <el-button size="mini" type="danger" @click="supplierUserDelete(item)" >Delete</el-button>
            </p>
          </div>
        </div>
      </el-card>

    </div>

  </div>
</template>

<script>
export default {
  name: 'SupplierQC',
  data () {
    return {
      loading: false,
      checkAll: false,
      isIndeterminate: true,
      checkedSupplierUser: [],
      qcUserList: [],
      supplierUserList: [],
      supplier: {},
      supplierInspector: '',
      switchShow: 'unshow',
      indexRole: {},
      users: [],
      permissions: [],
      role: {},
      roleList: [],
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialog: '',
      formInline: {
        roleName: '',
        supplierName: '',
        page: 1,
        rows: 100
      }
    }
  },
  created () {
    this.getSupplierList()
  },
  methods: {
    async supplierUserDelete (x) {
      this.loading = true
      await this.$http.get('/supplier/supplierUserDelete?id=' + x.org)
        .then((res) => {
          this.$http.get('/supplier/getSupplierUserList?supplierName=' + this.supplierInspector)
            .then((ress) => {
              this.supplierUserList = ress.data
              this.loading = false
            })
        })
    },
    async supplierUserSave () {
      console.log(this.checkedSupplierUser)
      this.loading = true
      await this.$http.post('/supplier/saveOrUpdateSupplierUserList?supplierName=' + this.supplierInspector, this.checkedSupplierUser)
        .then((res) => {
          if (res) {
            this.$http.get('/supplier/getSupplierUserList?supplierName=' + this.supplierInspector)
              .then((ress) => {
                this.supplierUserList = ress.data
                this.loading = false
              })
            this.$message({
              message: 'Added or updated successfully',
              type: 'success'
            })
            this.dialogFormVisible2 = false
          } else {
            this.$http.get('/supplier/getSupplierUserList?supplierName=' + this.supplierInspector)
              .then((ress) => {
                this.supplierUserList = ress.data
                this.loading = false
              })
            this.$message({
              message: 'Fail to add',
              type: 'warning'
            })
            this.dialogFormVisible2 = false
          }
        })
    },
    handleCheckAllChange (val) {
      const all = this.qcUserList.map(item => {
        return item.salesRep
      })
      this.checkedSupplierUser = val ? all : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange (value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.qcUserList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.qcUserList.length
    },
    async addUser () {
      this.qcUserList = []
      this.checkAll = false
      this.isIndeterminate = true
      this.checkedSupplierUser = []
      this.dialogFormVisible2 = true
      const { data: res } = await this.$http.get('/supplier/qcUserList')
      this.qcUserList = res
    },
    closeSwich () {
      this.switchShow = 'unshow'
      this.getSupplierList()
    },
    async customerDialogSave () {
      if (!this.supplier.supplierName) {
        this.$message({
          message: 'Supplier name is mandatory ',
          type: 'warning'
        })
        return
      }
      if (this.dialog === 'add') {
        await this.$http.post('/supplier/saveOrUpdateSupplierList', this.supplier)
          .then((res) => {
            if (res.data !== 501) {
              this.dialogFormVisible = false
              this.getSupplierList()
              this.$message({
                message: 'Added or updated successfully',
                type: 'success'
              })
            } else {
              this.$message({
                message: 'Supplier Name already exists',
                type: 'warning'
              })
            }
          })
      } else if (this.dialog === 'edit') {
        await this.$http.post('/supplier/saveOrUpdateSupplierList', this.supplier)
          .then((res) => {
            if (res.data !== 501) {
              this.dialogFormVisible = false
              this.getSupplierList()
              this.$message({
                message: 'Added or updated successfully',
                type: 'success'
              })
            } else {
              this.$message({
                message: 'Supplier Name already exists',
                type: 'warning'
              })
            }
          })
      } else {
        console.log(11)
      }
    },
    async getUsers (x) {
      document.documentElement.scrollTop = 0
      this.supplierUserList = []
      this.getSupplierUserList(x)
      this.supplierInspector = x.row.supplierName
      this.switchShow = 'show'
    },
    async getUsersOld (x) {
      this.users = []
      this.permissions = []
      this.dialogFormVisible2 = true
      this.dialog = 'Users'
      this.indexRole = x.row
      const { data: res } = await this.$http.get('/systemRole/getUsers' + '?id=' + x.row.id)
      this.users = res
    },
    async getPermissions (x) {
      this.users = []
      this.permissions = []
      this.dialogFormVisible2 = true
      this.dialog = 'Permissions'
      this.indexRole = x.row
      const { data: res } = await this.$http.get('/systemRole/getPermissions' + '?id=' + x.row.id)
      this.permissions = res
    },
    edit (x) {
      console.log(x.row)
      this.dialogFormVisible = true
      this.dialog = 'edit'
      this.supplier = x.row
    },
    onSubmit () {
      console.log('submit!')
      this.getSupplierList()
    },
    customerDialogOpen (x) {
      console.log('submit!')
      this.dialogFormVisible = true
      this.dialog = 'add'
      this.supplier = {}
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.formInline.rows = val
      // this.getUsers()
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.formInline.page = val
      // this.getUsers()
    },
    // async getUsers () {
    //   const { data: res } = await this.$http.get('/userManagement/userList', { params: this.formInline })
    //   this.userList = res.rows
    //   this.total = res.total
    // },
    async getSupplierList () {
      const { data: res } = await this.$http.get('/supplier/getSupplierList', { params: this.formInline })
      this.roleList = res
      this.total = res.total
    },
    async getSupplierUserList (x) {
      this.formInline.supplierName = x.row.supplierName
      const { data: res } = await this.$http.get('/supplier/getSupplierUserList', { params: this.formInline })
      this.formInline = {}
      this.supplierUserList = res
    }
  }

}

</script>

<style scoped>
  .show {
    width: 50%;
  }
  .unshow {
    width: 100%;
  }
</style>
